import React from 'react';
import GPTLogoWhite from '@/assets/GPTforme Logo White.svg';
import DriveSourceLogoWhite from '@/assets/DriveSource Logo White.svg';
import HomeSourceLogoWhite from '@/assets/HomeSource Logo White.svg';

export const Footer: React.FC = () => {
    const dn = import.meta.env.VITE_ASSISTANT_DISPLAY_NAME;
    const crossLink = dn === 'DriveSource'
        ? { label: 'HomeSource', url: 'https://gethomesource.com', logo: HomeSourceLogoWhite }
        : dn === 'HomeSource'
            ? { label: 'DriveSource', url: 'https://getdrivesource.com', logo: DriveSourceLogoWhite }
            : null;

    return (
        <div
            className="fixed bottom-0 left-0 right-0 bg-[#1a1a1a] border-t border-gray-600 z-30"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <div className="flex items-center justify-between px-2 sm:px-4 md:px-6 lg:px-8 py-1.5 sm:py-2 md:py-4" style={{ minHeight: '60px' }}>
                {/* Left: cross-link to other environment */}
                {crossLink ? (
                    <a
                        href={crossLink.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-1.5 text-gray-400 hover:text-gray-300 transition-colors"
                    >
                        <span className="text-xs sm:text-sm whitespace-nowrap">Visit</span>
                        <img src={crossLink.logo} alt={crossLink.label} className="h-3 sm:h-4 w-auto opacity-60 hover:opacity-100 transition-opacity" />
                    </a>
                ) : <div />}

                {/* Right: Powered by + Privacy/Terms */}
                <div className="flex flex-col items-end gap-0.5">
                    <div className="flex items-center gap-1 text-gray-400">
                        <span className="text-xs sm:text-sm whitespace-nowrap">Powered by</span>
                        <img src={GPTLogoWhite} alt="GPTforme" className="h-4 sm:h-5 w-auto opacity-60" />
                    </div>
                    <div className="flex items-center gap-2 sm:gap-3">
                        <a href="/GPTforme_privacy_policy.pdf" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-400 hover:text-cyan-400 transition-colors whitespace-nowrap">
                            Privacy Policy
                        </a>
                        <span className="text-gray-600 text-xs">|</span>
                        <a href="/GPTforme_terms_of_use.pdf" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-400 hover:text-cyan-400 transition-colors whitespace-nowrap">
                            Terms of Service
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
